import { Container } from './styled';

export default function Home() {
  return (
    <Container>
      <h1>Contato</h1>
    </Container>

  );
}
